<section class="custom-box1">
    <div class=" col-xs-12 col-md-12 col-lg-12 card tender-auction-section1">
        <div class="m-4">
            <div class="accordion" id="myAccordion">
                <div *ngFor="let content of accordianData; let inx = index" class="accordion-item">
                    <h2 class="accordion-header" id="heading-{{content.id}}">
                        <button type="button" class="accordion-button" [ngClass]="inx==0?'':'collapsed'" data-bs-toggle="collapse"
                            [attr.data-bs-target]="'#acc_item_' + content.id">
                            <cbic-static-text [textEn]="content.title.En"  
                                [textHi]="content.title.Hi" ></cbic-static-text>
                        </button>
                    </h2>
                    <div [id]="'acc_item_'+content.id" class="accordion-collapse collapse " [ngClass]="inx==0?'show':''" data-bs-parent="#myAccordion">
                        <div class="card-body">
                            <cbic-table [data]="content.data"></cbic-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>